import { createApp } from 'vue'
import { i18nVue } from 'laravel-vue-i18n'
import MasonryWall from '@yeger/vue-masonry-wall'

import AllStarGame from '../components/games/AllStarGame.vue'
import GameCenter from "../components/games/GameCenter.vue"
import LastMatch from "../components/home/LastMatch.vue"
import HomeTeamPlayers from '../components/home/HomeTeamPlayers.vue'


const homeApp = createApp({})

homeApp
    .use(MasonryWall)
    .use(i18nVue, {
        resolve: lang => import(`../../../lang/${lang}.json`),
    })

homeApp
    .component('AllStarGame', AllStarGame)
    .component('GameCenter', GameCenter)
    .component('LastMatch', LastMatch)
    .component('HomeTeamPlayers', HomeTeamPlayers)

homeApp.mount('#homeApp')
